import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { useUsageTracker } from 'marketplace-ui-tracking';
import { useEffect, useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import { useHistory, useLocation } from 'react-router-dom';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { HeaderView } from '../components/headers/HeaderView';
import { Paths } from '../constants/paths';
import { StorefrontFilterBar } from '../filters/components/StorefrontFilterBar';
import { KEY_PREFIX } from '../hooks/useSearchParams';
import { ResultsGrid } from './components/ResutsGrid';
import { SearchResultsHeader } from './components/SearchResultsHeader';
import { parseSearchResultsPath } from './utils/parseSearchResultsPath';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SearchResultsPage() {
  const usageTracker = useUsageTracker();
  const location = useLocation();
  const parsedPath = useMemo(() => parseSearchResultsPath(location.pathname), [location.pathname]);
  useConvertPathParamsToSearchParams(parsedPath);
  useEffect(() => {
    usageTracker.track('pageView', {
      screen: 'generated-app-route',
      subscreen: 'searchResults'
    });
  }, [usageTracker]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "EXPLORE_LOAD",
    children: /*#__PURE__*/_jsx(DashboardPage, {
      headerComponent: /*#__PURE__*/_jsx(HeaderView, {}),
      children: /*#__PURE__*/_jsxs(ErrorBoundary, {
        children: [/*#__PURE__*/_jsx(SearchResultsHeader, {
          parsedPath: parsedPath
        }), /*#__PURE__*/_jsx(StorefrontFilterBar, {}), /*#__PURE__*/_jsx(ResultsGrid, {})]
      })
    })
  });
}
function useConvertPathParamsToSearchParams(parsedPath) {
  const history = useHistory();
  useEffect(() => {
    if (Object.keys(parsedPath).length === 0) return;
    const urlParams = new URLSearchParams();
    Object.entries(parsedPath).forEach(([key, value]) => {
      if (value) urlParams.set(`${KEY_PREFIX}${key}`, value.toString());
    });
    history.replace(`${Paths.SEARCH_RESULTS}?${urlParams.toString()}`);
  }, [parsedPath, history]);
}